<template>
  <div id="app" class="container-fuild pb-2">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>
